<div class="pt-4" *ngIf="serverError !== null">
  <div class="alert alert-danger">
    Server Error: {{ serverError }}
  </div>
</div>

<div class="pt-4 pl-md-4 pr-md-4 mb-6" *ngIf="serverError === null">

  <div class="d-flex flex-column flex-sm-row mb-2" style="gap: 8px;">
    <input type="text"
           class="form-control flex-grow-1"
           placeholder="Search by event type, roster, or schedule"
           [(ngModel)]="filters.search"
           (ngModelChange)="handleFilterChange()">
    <select class="custom-select w-auto"
            [(ngModel)]="filters.location_id"
            (ngModelChange)="handleFilterChange()">
      <option [ngValue]="undefined">Location: Any</option>
      <option *ngFor="let location of locations" [ngValue]="location.id">
        Location: {{ location.name }}
      </option>
    </select>
  </div>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table table-hover"
           *ngIf="!loadingRosters && (filteredRosters.length > 0)">
      <thead>
        <tr>
          <th>Event Type</th>
          <th>Roster</th>
          <th>Location</th>
          <th class="d-none d-sm-table-cell">Schedule(s)</th>
          <th class="d-none d-md-table-cell">
            <span ngbTooltip="Count of active, frozen, and payment-failed memberships assigned to this roster. Matches the default set shown by the View Members report.">
              # Members
            </span>
          </th>
          <th class="text-nowrap text-right position-sticky" style="right:0;"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let roster of filteredRosters">
          <td>{{ roster.event_type_name }}</td>
          <td>{{ roster.name }}</td>
          <td>{{ roster.location_name }}</td>
          <td class="d-none d-sm-table-cell">
            <div *ngFor="let schedule of roster.schedules">
              <a routerLink="/events/setup/edit/{{ roster.event_type_id }}/schedules/{{ schedule.id }}">
                {{ scheduleDisplay(schedule) }}
              </a>
            </div>
            <span *ngIf="roster.schedules.length === 0" class="text-muted">No schedules</span>
          </td>
          <td class="d-none d-md-table-cell">{{ roster.current_member_count }}</td>
          <td class="table-button-cell text-right position-sticky" style="right:0;">
            <div class="d-flex justify-content-end" style="gap: 12px;">
              <a class="btn btn-outline-primary btn-sm bg-white-not-important"
                 routerLink="/reporting/roster-members"
                 [queryParams]="{ roster_id: roster.id }">
                View Members
              </a>
              <a class="btn btn-outline-primary btn-sm bg-white-not-important"
                 routerLink="/events/setup/edit/{{ roster.event_type_id }}/rosters/{{ roster.id }}">
                Edit Roster
              </a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <table class="table"
           *ngIf="loadingRosters || (filteredRosters.length === 0)">
      <tbody>
        <tr>
          <td colspan="99">
            <ng-container *ngIf="loadingRosters">Loading...</ng-container>
            <ng-container *ngIf="!loadingRosters && allRosters.length === 0">
              No rosters set up yet.
            </ng-container>
            <ng-container *ngIf="!loadingRosters && allRosters.length > 0">
              No rosters match your filters.
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</div>
